<script lang="ts">
  import { router } from "../../router.svelte";
  import { session } from "../stores/session.svelte";
  import Menu from "./Menu.svelte";
  import type { MenuItem } from "./types";

  interface Props {
    items?: MenuItem[];
  }

  const { items = [] }: Props = $props();
  let loggingOut = $state(false);

  const accountLabel = $derived(
    session.user?.displayName ? `Account menu for ${session.user.displayName}` : "Account menu"
  );
  const menuItems = $derived<MenuItem[]>([
    ...items,
    {
      id: "about",
      label: "About",
      description: "EpiDev wiki",
      href: "https://epidev.ai/wiki/",
      external: true,
      onSelect: () => {}
    },
    {
      id: "logout",
      label: loggingOut ? "Logging out..." : "Log out",
      danger: true,
      disabled: loggingOut,
      separatorBefore: true,
      onSelect: logOut
    }
  ]);

  async function logOut(): Promise<void> {
    if (loggingOut) return;
    loggingOut = true;
    try {
      await session.logout();
      router.navigate("/signed-out", { replace: true });
    } finally {
      loggingOut = false;
    }
  }
</script>

<Menu
  items={menuItems}
  label={accountLabel}
  busy={loggingOut}
  header={session.user
    ? { label: session.user.displayName, description: session.user.email }
    : undefined}
/>
